import { create } from 'zustand';
import update from 'immutability-helper';
import Utils from 'files/Utils.js';

export const useDataStore = create(set => {

    const getRequiemFunctions = () => {
        return {
            conversations: {
                start: props => {
                    setRequiem(requiem => {
                        requiem.request = {
                            action: 'conversation_start',
                            data: props
                        }
                        return requiem;
                    });
                }
            },
            resources: {
                interactions: {
                    cancel: ({ resource }) => {
                        setRequiem(requiem => {

                            // notify requiem that a review was cancelled if applicable
                            if(requiem.review && requiem.review.id === resource.target?.id) {
                                console.log(`[requiem]: cancelling review for ${resource.target.id}`);
                                requiem.message = `I cancelled my review for my ${resource.category} setup.`;
                                return requiem;
                            }

                            // fallback to sending a request to cancel smart flow
                            console.log(`[requiem]: cancelling smart flow for ${resource.target?.id || resource.category}`);
                            requiem.request = { action: 'smart_flow_cancel' }; 
                            return requiem;
                        });
                    },
                    complete: ({ resource, reviewed }) => {
                        setRequiem(requiem => {

                            let { smart_flow, review } = requiem;

                            // notify requem that a review was completed if applicable
                            if(review && review.id === resource.target?.id && reviewed === true) {
                                console.log(`[requiem]: completing review for ${resource.target.id}`);
                                return update(requiem, {
                                    message: { 
                                        $set: `I reviewed and confirmed the details for my ${resource.category} setup.`
                                    }
                                });
                            }

                            // notify requiem that smart flow was completed if applicable
                            if(smart_flow && smart_flow.enabled === true && smart_flow.id === resource.id) {
                                console.log(`[requiem]: completing smart flow for ${resource.target?.id || resource.category}`);
                                return update(requiem, {
                                    smart_flow: { 
                                        completed: { 
                                            $set: true 
                                        } 
                                    }
                                });
                            }
                            return requiem;
                        });
                    },
                    start: ({ resource }) => {
                        setRequiem(requiem => {

                            // enable smart flow if review is active and smart_flow was requested
                            if(requiem.review && requiem.review.id === resource.id && requiem.review.smart_flow === true) {
                                console.log(`[requiem]: starting smart flow for ${resource.target?.id || resource.category} review`);
                                requiem.smart_flow = { 
                                    enabled: true,
                                    ...resource
                                };
                                return requiem;
                            }

                            // disable existing smart flow if different resource is requested
                            if(requiem.smart_flow) {
                                console.log(`[requiem]: ending smart flow for ${requiem.smart_flow.id}`);
                                requiem.smart_flow = null;
                            }

                            // fallback to sending a request to prompt for smart flow
                            console.log(`[requiem]: requesting smart flow for ${resource.target?.id || resource.category}`);
                            return update(requiem, {
                                request: {
                                    $set: { 
                                        action: 'smart_flow_start', 
                                        category: resource.category,
                                        resource
                                    }
                                }
                            });
                        });
                    }
                }
            },
            smart_flow: {
                cancel: resource => {
                    setRequiem(requiem => {
                        if(requiem.smart_flow?.id === resource.id) {
                            requiem.request = { 
                                action: 'smart_flow_cancel',
                                smart_flow: { 
                                    id: requiem.smart_flow.id,
                                    title: requiem.smart_flow.title
                                }
                            };
                        }
                        return requiem;
                    });
                },
                complete: resource => {
                    setRequiem(requiem => {
                        if(requiem.smart_flow?.id === resource.id) {
                            requiem.request = { 
                                action: 'smart_flow_complete',
                                smart_flow: { 
                                    id: requiem.smart_flow.id,
                                    title: requiem.smart_flow.title
                                }
                            };
                        }
                        return requiem;
                    });
                }
            },
        }
    }

    const setRequiem = target => {
        return set(state => {
            let result = typeof(target) === 'function' ? target(state.requiem) : target;
            return { 
                requiem: {
                    ...result,
                    functions: getRequiemFunctions()
                }
            }
        });
    }

    return {
        advertising_metadata: null,
        onboarding: {
            enabled: true,
            visible: false
        },
        partnership: null,
        partneredUser: null,
        referredByUserCode: null,
        request: {},
        requiem: { functions: getRequiemFunctions() },
        sockets: { connected: false },
        system: { 
            window: {
                isMobile: Utils.isMobile(),
                size: {
                    height: 0,
                    width: 0
                }
            }
        },
        user: null,
        setAdvertisingMetadata: target => set(state => ({ advertising_metadata: typeof(target) === 'function' ? target(state.advertising_metadata) : target })),
        setOnboarding: target => set(state => ({ onboarding: typeof(target) === 'function' ? target(state.onboarding) : target })),
        setPartnership: target => set(state => ({ partnership: typeof(target) === 'function' ? target(state.partnership) : target })),
        setPartneredUser: target => set(state => ({ partneredUser: typeof(target) === 'function' ? target(state.partneredUser) : target })),
        setReferredByUserCode: target => set(state => ({ referredByUserCode: typeof(target) === 'function' ? target(state.referredByUserCode) : target })),
        setRequest: target => set(state => ({ request: typeof(target) === 'function' ? target(state.request) : target })),
        setRequiem: setRequiem,
        setUser: target => set(state => ({ user: typeof(target) === 'function' ? target(state.user) : target })),
        setSockets: target => set(state => ({ sockets: typeof(target) === 'function' ? target(state.sockets) : target })),
        setSystem: target => set(state => ({ system: typeof(target) === 'function' ? target(state.system) : target }))
    }
})